import styles from "./Logo.module.scss";

const Logo = ({ src }) => {
  return (
    <div className={styles.logoIcon}>
      <img alt="logo" src={src} />
    </div>
  );
};

export default Logo;
